import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BlogGuide from "../pages/blog/itaobuyspreadsheet-guide/page";
import BlogHowToUse from "../pages/blog/how-to-use-itaobuyspreadsheet/page";
import BlogBestLists from "../pages/blog/best-itaobuyspreadsheet-lists/page";
import BlogVsTraditional from "../pages/blog/itaobuyspreadsheet-vs-traditional-shopping/page";
import BlogIsSafe from "../pages/blog/is-itaobuyspreadsheet-safe/page";
import BlogTopBenefits from "../pages/blog/top-benefits-itaobuyspreadsheet/page";
import BlogBeginnerTips from "../pages/blog/itaobuyspreadsheet-beginner-tips/page";
import BlogFutureShopping from "../pages/blog/future-structured-shopping-itaobuyspreadsheet/page";
import BlogCategoryDeepDive from "../pages/blog/itaobuyspreadsheet-category-deep-dive/page";
import BlogMaximizeBudget from "../pages/blog/maximize-budget-itaobuyspreadsheet/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/blog/itaobuyspreadsheet-guide",
    element: <BlogGuide />,
  },
  {
    path: "/blog/how-to-use-itaobuyspreadsheet",
    element: <BlogHowToUse />,
  },
  {
    path: "/blog/best-itaobuyspreadsheet-lists",
    element: <BlogBestLists />,
  },
  {
    path: "/blog/itaobuyspreadsheet-vs-traditional-shopping",
    element: <BlogVsTraditional />,
  },
  {
    path: "/blog/is-itaobuyspreadsheet-safe",
    element: <BlogIsSafe />,
  },
  {
    path: "/blog/top-benefits-itaobuyspreadsheet",
    element: <BlogTopBenefits />,
  },
  {
    path: "/blog/itaobuyspreadsheet-beginner-tips",
    element: <BlogBeginnerTips />,
  },
  {
    path: "/blog/future-structured-shopping-itaobuyspreadsheet",
    element: <BlogFutureShopping />,
  },
  {
    path: "/blog/itaobuyspreadsheet-category-deep-dive",
    element: <BlogCategoryDeepDive />,
  },
  {
    path: "/blog/maximize-budget-itaobuyspreadsheet",
    element: <BlogMaximizeBudget />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;